export default __webpack_public_path__ + "static/media/Twitter.a46dbb52.svg";